var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoadmap = function SvgRoadmap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    fillRule: "evenodd",
    d: "M19.876 12.5a9 9 0 0 0 0-3H36.29c-.188.463-.291.97-.291 1.5s.103 1.037.29 1.5zm23.833 0c.188-.463.291-.97.291-1.5s-.103-1.037-.29-1.5H48c7.456 0 13.5 6.044 13.5 13.5 0 6.49-4.58 11.911-10.685 13.206.12-.38.185-.786.185-1.206 0-.654-.157-1.27-.435-1.816C55.125 32.04 58.5 27.914 58.5 23c0-5.799-4.701-10.5-10.5-10.5zM43 35c0 .53.103 1.037.29 1.5H23c-1.878 0-3.64.493-5.166 1.356a4 4 0 0 0-1.903-2.36A13.44 13.44 0 0 1 23 33.5h20.29c-.187.463-.29.97-.29 1.5m-29.687 7.941a4 4 0 0 1-2.567-1.614A13.45 13.45 0 0 0 9.5 47c0 7.215 5.66 13.109 12.783 13.481A4 4 0 0 1 22 59c0-.54.107-1.053.3-1.523-5.473-.36-9.8-4.913-9.8-10.477 0-1.439.29-2.81.813-4.059M51.124 60.5H29.71c.188-.463.291-.97.291-1.5s-.103-1.037-.29-1.5h21.414a9 9 0 0 0 0 3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M19.876 9.5H16.5a1.5 1.5 0 0 0 0 3h3.376a9 9 0 1 1 0-3",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2A8",
    fillRule: "evenodd",
    d: "M51.124 60.5C51.84 64.757 55.54 68 60 68a9 9 0 1 0 0-18c-4.46 0-8.161 3.243-8.876 7.5H55a1.5 1.5 0 0 1 0 3z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 11,
    r: 4,
    stroke: "#FF9D43",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 35,
    r: 4,
    stroke: "#2F68D1",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 39,
    r: 4,
    stroke: "#FF9D43",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 59,
    r: 4,
    stroke: "#2F68D1",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
};
export default SvgRoadmap;